import { Center, Spacer, Spinner, Text, Box, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import AppCard from 'presentation/components/shared/card/AppCard';
import GeneralCompensationCard from 'presentation/components/modules/compensation/GeneralCompensationCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { useCompensationListQuery } from 'rtkQuery/sharespro/queries/compensation';
const CompensationPage: FC = () => {
    const { data, isLoading, error, refetch } = useCompensationListQuery({
        data: {},
    });
    const { t } = useTranslation();

    let isWrappedByCard = true;
    let content;

  function convertUnixToMSK(unixTimestamp: number): string {
    const date = new Date(unixTimestamp * 1000);
    const utcTime = date.getTime();
    const mskTime = new Date(utcTime + (3 * 60 * 60 * 1000));

    // Форматируем дату в строку (дд.мм.гггг)
    const day = mskTime.getDate().toString().padStart(2, '0');
    const month = (mskTime.getMonth() + 1).toString().padStart(2, '0'); // Месяцы начинаются с 0
    const year = mskTime.getFullYear();

    return `${day}.${month}.${year}`; // Возвращаем дату в формате дд.мм.гггг
  }

    if (isLoading) {
        content = (
            <Center>
                <Spinner />
            </Center>
        );
    } else if (data?.data) {
        const totalCompensationAmount = data.data.total_compensation_amount || 0;
        const totalCompensationProgress = data.data.total_compensation_progress || 0;
        const compensations = data.data.compensations || [];

        if (totalCompensationAmount > 0 && totalCompensationProgress) {
            content = (
                <AppCard p="10px 20px">
                    {compensations.map((compensation, index) => (
                        <Flex
                            key={index}
                            justify="space-between"
                            borderBottom={index < compensations.length - 1 ? '1px' : 'none'}
                            borderColor="gray.200"
                            py={2}
                        >
                            <Box flex="1" mr={2}>
                                <Flex direction="column">
                                    <Text
                                        fontSize='16px'
                                        fontWeight='400'
                                        color='#000'>
                                        {compensation.name}
                                    </Text>
                                    <Text
                                        color='#000'
                                        fontWeight='500'
                                        fontSize='12px'>
                                        {convertUnixToMSK(compensation.date).toLocaleString()}
                                    </Text>
                                </Flex>
                            </Box>
                            <Box flex="1" ml={2}>
                                <Flex direction="column" alignItems='flex-end'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='400'
                                        color={compensation.operation === 1 ? '#40D9B5' : '#FF7F7F'}>
                                        {compensation.operation === 1 ? '+' : '-'}{compensation.amount} $
                                    </Text>
                                    <Text
                                        color={'#000'}
                                        fontWeight={500}
                                        fontSize={'12px'}>
                                        {compensation.operation === 1 ? t('accrualCompensation') : t('writeOffCompensation')}
                                    </Text>
                                </Flex>
                            </Box>
                        </Flex>
                    ))}
                </AppCard>
            );
        } else {
            content = (
                <Center>
                    {t('noCompensationAvailable')}
                </Center>
            );
        }

        isWrappedByCard = false;
    } else if (error) {
        content = (
            <Center>
                <ErrorContainer
                    error={error}
                    onRetry={() => {
                        refetch();
                    }}
                />
            </Center>
        );
    }
  if (isWrappedByCard) {
    content = (
      <AppCard w="100%" p="40px">
        {content}
      </AppCard>
    );
  }

  return (
    <SettingsLayout>
      <Helmet>
        <title>{t('compensationPageTitle')}</title>
      </Helmet>
      <GridHeading>{t('compensationPageTitle')}</GridHeading>

        <AppCard p="40px">
            <Text fontFamily='GTWalsheimPro' fontSize='14px' fontWeight='700' lineHeight='18px' textAlign='left' mb='25px'>
                {t('compensationPageTextFirst')}
            </Text>
            <Text fontFamily='GTWalsheimPro' fontSize='14px' fontWeight='700' lineHeight='18px' textAlign='left' >
                {t('compensationPageTextSecond')}
            </Text>
        </AppCard>
        <Spacer h="20px" />
        {data?.data && data.data.total_compensation_amount > 0 && data.data.total_compensation_progress > 0 && (
            <GeneralCompensationCard
                amount={data.data.total_compensation_amount}
                progress={data.data.total_compensation_progress}
            />
        )}
        <Spacer h="20px" />
      {content}
    </SettingsLayout>
  );
};

export default CompensationPage;
